import { Component } from '@angular/core';

@Component({
    selector: 'app-migration-sniper-wrapper',
    templateUrl: './migration-sniper-wrapper.component.html',
    styleUrls: ['./migration-sniper-wrapper.component.less'],
    standalone: false,
})
export class MigrationSniperWrapperComponent {}
